module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/core.module/components/not-found.component/not-found.component.css
// module id = ./src/app/core.module/components/not-found.component/not-found.component.css
// module chunks = main